import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { ScreenPreview } from '@micromag/core/components';

// import Authors from '../partials/Authors';

import styles from '../../../styles/items/screen.module.scss';

const propTypes = {
    item: MicromagPropTypes.screen.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ScreenItem = ({ item, className }) => (
    <ScreenPreview screen={item} withSize className={className} />
);

ScreenItem.defaultProps = defaultProps;
ScreenItem.propTypes = propTypes;

export default ScreenItem;
